
export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <h3 className="text-2xl font-bold mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
              琉球スタートアップ
            </h3>
            <p className="text-gray-300 mb-4">
              沖縄で起業する美容・カフェ・サロン事業者向けの高品質LP・ホームページ制作サービス。
              琉球人による現地視点でのデザインとコンテンツで地域密着型ビジネスを成功に導きます。
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                <i className="ri-instagram-line text-xl"></i>
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold mb-4">サービス</h4>
            <ul className="space-y-2">
              <li><a href="#" className="text-gray-300 hover:text-white transition-colors cursor-pointer">ホームページ制作</a></li>
              <li><a href="#" className="text-gray-300 hover:text-white transition-colors cursor-pointer">ランディングページ</a></li>
              <li><a href="#" className="text-gray-300 hover:text-white transition-colors cursor-pointer">SEO対策</a></li>
              <li><a href="#" className="text-gray-300 hover:text-white transition-colors cursor-pointer">デジタルマーケティング</a></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-semibold mb-4">お問い合わせ</h4>
            <ul className="space-y-2">
              <li className="text-gray-300">
                <i className="ri-mail-line mr-2"></i>
                ryukyu.startup@gmail.com
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2024 琉球スタートアップ. All rights reserved.
          </p>
          <a 
            href="https://readdy.ai/?origin=logo" 
            className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer mt-2 md:mt-0"
            rel="nofollow"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
